import ROLES from '../../roles'

export default {
  /**
     * @path http://localhost:8081/#/accounts
     * Prevent user from deleting the account
     */
  CAN_DELETE_ACCOUNTS: [ROLES.ADMIN],
  CAN_NOT_VIEW_ADMIN: [ROLES.SALES], // roles which can NOT view admin accounts
  CAN_NOT_VIEW_DRIVER: [ROLES.MANAGER], // roles which can NOT view tow Drivers
  CAN_NOT_EDIT_ADD_APT_ACCOUNTS: [], // roles which can NOT view add APT-> Accounts
  CAN_ADD_PASSWORD: [ROLES.ADMIN, ROLES.PB_FIELD_AGENT], // roles which can NOT view add APT-> Accounts
  CAN_VIEW_ACCOUNT_LOGS: [ROLES.ADMIN]
}



// WEBPACK FOOTER //
// ./src/roles/rules/accounts/index.js